import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'

interface IProgressBarModalProps {
  isOpen: boolean
  duration: number
  title: string
}
const ProgressBarModal = (props: IProgressBarModalProps) => {
  const { isOpen, duration, title } = props
  const [progress, setProgress] = useState(0)
  const interval = 100

  useEffect(() => {
    if (isOpen === true) {
      const increment = (interval / duration) * 100
      let currentValue = 0

      const intervalId = setInterval(() => {
        currentValue += increment
        if (currentValue >= 100) {
          currentValue = 100
          clearInterval(intervalId)
        }
        setProgress(currentValue)
      }, interval)

      return () => clearInterval(intervalId)
    } else {
      setProgress(0)

      return () => console.log('Modal closed')
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} className='Modal' ariaHideApp={false}>
      <div className='overlay bg-dark-grey' />
      <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
        <div className='bg-white col-4 p2'>
          <div className='weight-300 font-grey2 ml2 mr2 mb1 h3 mt3'>{title}</div>
          <div className='weight-300 font-grey2 ml2 mr2 mb1 h4'>Please do not refresh or leave the current page.</div>
          <div className='flex mx2 my3'>
            <progress max={100} value={progress} className='progress-bar' />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ProgressBarModal



// WEBPACK FOOTER //
// ./src/components/trips/route-optimization/ProgressBarModal.tsx